import React from 'react';
import PricingHeader from './pricing_header';
import PricingTable from './pricing_table';
import PricingFooter from './pricing_footer';

function AdvancePriceField({ pricingSchema, unit }) {
  const {
    minimum_price: minimumPrice,
    price,
    schema_type: schemaType,
    pricing_ranges: pricingRanges,
  } = pricingSchema;

  return (
    <>
      <PricingHeader schemaType={schemaType} unit={unit} />
      <PricingTable pricingRanges={pricingRanges} />
      <PricingFooter minimumPrice={minimumPrice} price={price} />
    </>
  );
}

export default AdvancePriceField;
